var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#patternNL)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "patternNL",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_8917_2530",
    transform: "translate(-0.251366) scale(0.00546448)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_8917_2530",
    width: 275,
    height: 183,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARMAAAC3CAIAAAC+MS2jAAAEO0lEQVR4Ae3VoZHDUBAFwQ1ERMzAcSgucwdiphTlGHZwXwnekq4/z3MfLx8BAluB2R74fwIE7uOlHD+5BIqAcoqa0SWgHOUQKALKKWoWl4BylEOgCCinqFlcAspRDoEioJyiZnEJKEc5BIqAcoqaxSWgHOUQKALKKWoWl4BylEOgCCinqFlcAspRDoEioJyiZnEJKEc5BIqAcoqaxSWgHOUQKALKKWoWl4BylEOgCCinqFlcAspRDoEioJyiZnEJKEc5BIqAcoqaxSWgHOUQKALKKWoWl4BylEOgCCinqFlcAspRDoEioJyiZnEJKEc5BIqAcoqaxSWgHOUQKALKKWoWl4BylEOgCCinqFlcAspRDoEioJyiZnEJKEc5BIqAcoqaxSWgHOUQKALKKWoWl4BylEOgCCinqFlcAspRDoEioJyiZnEJKEc5BIqAcoqaxSWgHOUQKALKKWoWl4BylEOgCCinqFlcAspRDoEioJyiZnEJKEc5BIqAcoqaxSUwv/ERILAWmMcfAQJ7AeXszVwQeB7leAUEioByipobAsrxBggUAeUUNTcElOMNECgCyilqbggoxxsgUASUU9TcEFCON0CgCCinqLkhoBxvgEARUE5Rc0NAOd4AgSKgnKLmhoByvAECRUA5Rc0NAeV4AwSKgHKKmhsCyvEGCBQB5RQ1NwSU4w0QKALKKWpuCCjHGyBQBJRT1NwQUI43QKAIKKeouSGgHG+AQBFQTlFzQ0A53gCBIqCcouaGgHK8AQJFQDlFzQ0B5XgDBIqAcoqaGwLK8QYIFAHlFDU3BJTjDRAoAsopam4IKMcbIFAElFPU3BBQjjdAoAgop6i5IaAcb4BAEVBOUXNDQDneAIEioJyi5oaAcrwBAkVAOUXNDQHleAMEioByipobAsrxBggUAeUUNTcElOMNECgCyilqbggoxxsgUASUU9TcEFCON0CgCCinqLkhoBxvgEARmHl/fAQIrAXO6+sjQGArMNsD/0+AwHl9leMnl0ARUE5RM7oElKMcAkVAOUXN4hJQjnIIFAHlFDWLS0A5yiFQBJRT1CwuAeUoh0ARUE5Rs7gElKMcAkVAOUXN4hJQjnIIFAHlFDWLS0A5yiFQBJRT1CwuAeUoh0ARUE5Rs7gElKMcAkVAOUXN4hJQjnIIFAHlFDWLS0A5yiFQBJRT1CwuAeUoh0ARUE5Rs7gElKMcAkVAOUXN4hJQjnIIFAHlFDWLS0A5yiFQBJRT1CwuAeUoh0ARUE5Rs7gElKMcAkVAOUXN4hJQjnIIFAHlFDWLS0A5yiFQBJRT1CwuAeUoh0ARUE5Rs7gElKMcAkVAOUXN4hJQjnIIFAHlFDWLS0A5yiFQBJRT1CwuAeUoh0ARUE5Rs7gElKMcAkVAOUXN4hJQjnIIFAHlFDWLS0A5yiFQBJRT1CwuAeUoh0ARUE5Rs7gE/o36KpaM/Fe8AAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNl);
export default __webpack_public_path__ + "static/media/NL.82025d7c4a96c7adaed32422940b6ce9.svg";
export { ForwardRef as ReactComponent };